const t = "Okno modalne", o = "Zamknij", e = {
  title: t,
  close: o
};
export {
  o as close,
  e as default,
  t as title
};
